module.exports = __webpack_public_path__ + "img/6.80cd2f74.jpg";